<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
        id="help-btn"
        v-on="on"
        fab
        @click="onClick"
        color="accent"
        class="ml-3 mr-4"
        elevation="0"
        x-small
        href="https://horusaeronaves.atlassian.net/servicedesk/customer/portal/1"
        target="_blank"
      >
        <v-icon color="white">mdi-help</v-icon>
      </v-btn>
    </template>
    <span>Suporte</span>
  </v-tooltip>
</template>

<script>

  export default {
    name: "HelpButton",
  }
</script>

<style scoped>

</style>